import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './EmployeeTable.css';
import './tablestyle.css';
import ExcelDownload from "./ExcelDownload";
// const [search, setSearch] = useState(""); // 🔎 Search
// const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" }); // ↕ Sort

const SubmodalityTable = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [submodalityList, setSubmodalityList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState(""); // 🔎 Search
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" }); // ↕ Sort
  const navigate = useNavigate();

   const fetchSubmodalityList = () => {
    setLoading(true);
    fetch(`${baseUrl}/getSubModalities`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status && Array.isArray(data.data)) {
          setSubmodalityList(data.data);
        } else {
          setSubmodalityList([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching Sub modality list:', err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchSubmodalityList();
  }, []);

  const handleEditClick = async (id) => {
 
    navigate(`/submodality/edit/${id}`);
  }

  const handleDeleteClick = async (id) => {
    if (!window.confirm('Are you sure you want to delete this Sub modality?')) {
      return;
    }

    try {
      const response = await fetch(
        `${baseUrl}/deleteSubModalityById/${id}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      const result = await response.json();

      if (result.status) {
        alert('Submodality deleted successfully!');
        fetchSubmodalityList(); // refresh table
      } else {
        alert(result.message || 'Failed to delete Sub modality.');
      }
    } catch (error) {
      console.error('Error deleting Submodality:', error);
      alert('An error occurred while deleting.');
    }
  };

  // 🔎 Filtering
  const filteredData = submodalityList.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  // ↕ Sorting
  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const valA = a[sortConfig.key] || "";
    const valB = b[sortConfig.key] || "";
    if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
    if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  if (loading) {
    return <div>Loading Submodality data...</div>;
  }

  return (
  <div className="employee-table-container">
    <div className="table-scroll">
      <div className="d-flex justify-content-between align-items-center mb-3">

        {/* 🔎 Search Box */}
          <input
            type="text"
            placeholder="Search..."
            className="form-control w-25"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

        {/* ✅ Excel Download Button */}
        <ExcelDownload
          data={submodalityList.map((item, index) => ({
            S_No: index + 1,
            Modality: item.mod_name,
            Service_ID: item.service_id,
            Submodality: item.sub_mod_name,
            Class_Type: item.sub_mod_class,
            Status: item.status === "A" ? "Active" : "Inactive",
            Created_By: item.created_by,
            Created_On: item.created_on,
            Modified_By: item.modified_by || "-",
            Modified_On: item.modified_on || "-",
          }))}
          fileName="SubmodalityMaster.xlsx"
          sheetName="Submodalities"
        />
      </div>

      <table className="employee-table">
        <thead>
          <tr>
              <th onClick={() => requestSort("id")}>S.No</th>
              <th onClick={() => requestSort("mod_name")}>Modality</th>
              <th onClick={() => requestSort("service_id")}>Service ID</th>
              <th onClick={() => requestSort("sub_mod_name")}>Submodality</th>
              <th onClick={() => requestSort("sub_mod_class")}>Class Type</th>
              <th onClick={() => requestSort("status")}>Status</th>
              <th onClick={() => requestSort("created_by")}>Created By</th>
              <th onClick={() => requestSort("created_on")}>Created On</th>
              <th onClick={() => requestSort("modified_by")}>Modified By</th>
              <th onClick={() => requestSort("modified_on")}>Modified On</th>
              <th>Actions</th>
          </tr>
        </thead>
        <tbody>
            {sortedData.length > 0 ? (
              sortedData.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.mod_name}</td>
                  <td>{item.service_id}</td>
                  <td>{item.sub_mod_name}</td>
                  <td>{item.sub_mod_class}</td>
                  <td>
                    <span
                      className={`status-badge ${
                        item.status === "A" ? "active" : "inactive"
                      }`}
                    >
                      {item.status === "A" ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td>{item.created_by}</td>
                  <td>{item.created_on}</td>
                  <td>{item.modified_by || "-"}</td>
                  <td>{item.modified_on || "-"}</td>
                  <td>
                    <button
                      className="action-button edit"
                      onClick={() => handleEditClick(item.id)}
                    >
                      Edit
                    </button>
                    <button
                      className="action-button delete"
                      onClick={() => handleDeleteClick(item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" style={{ textAlign: "center" }}>
                  No Sub modality data found
                </td>
              </tr>
            )}
          </tbody>
        {/* <tbody>
          {submodalityList.length > 0 ? (
            submodalityList.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.mod_name}</td>
                <td>{item.service_id}</td>
                <td>{item.sub_mod_name}</td>
                <td>{item.sub_mod_class}</td>
                <td>
                  <span
                    className={`status-badge ${
                      item.status === "A" ? "active" : "inactive"
                    }`}
                  >
                    {item.status === "A" ? "Active" : "Inactive"}
                  </span>
                </td>
                <td>{item.created_by}</td>
                <td>{item.created_on}</td>
                <td>{item.modified_by || "-"}</td>
                <td>{item.modified_on || "-"}</td>
                <td>
                  <button
                    className="action-button edit"
                    onClick={() => handleEditClick(item.id)}
                  >
                    Edit
                  </button>
                  <button
                    className="action-button delete"
                    onClick={() => handleDeleteClick(item.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="11" style={{ textAlign: "center" }}>
                No Sub modality data found
              </td>
            </tr>
          )}
        </tbody> */}
        
      </table>
    </div>
  </div>
);

};

export default SubmodalityTable;
